module.exports = __webpack_public_path__ + "img/69.5161ab07.jpg";